<template>
  <v-dialog :value="open" max-width="640px" persistent @keydown.esc="stay">
    <v-card>
      <v-card-title>Är du där?</v-card-title>

      <v-card-text>
        Du har varit inaktiv för länge och loggas därför ut om
        {{ seconds }} sekunder.
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="stay">
          <v-icon small>mdi-lightbulb-on</v-icon>
          Fortsätt vara inloggad
        </v-btn>
        <v-btn @click="logout">
          <v-icon>$logout</v-icon>
          Logga ut
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { idleState, stayIdleSession } from "@/services/idleSessionService";

export default {
  name: "ConfirmLogoutDialog",
  data() {
    return {
      busy: false,
    };
  },
  computed: {
    open() {
      return idleState.status === "warning";
    },
    seconds() {
      return Math.max(0, Math.ceil(idleState.remainingMs / 1000));
    },
  },
  methods: {
    async stay() {
      this.busy = true;
      try {
        // Extend the server session first. If it is already gone, the request
        // fails with 401 and the interceptor logs the user out.
        await this.$store.dispatch("ping");
        stayIdleSession();
      } finally {
        this.busy = false;
      }
    },
    logout() {
      this.$emit("logout", "dialog");
    }
  },
};
</script>
